export default __webpack_public_path__ + "static/media/prediction-image.fe76f636.png";